import React from "react";
var __jsx = React.createElement;
import CostumeCheckBox from "../../../../../../../../UiKit/CostumeCheckBox/CostumeCheckBox";
import ShapeCheckBox from "../../../../ShapeCheckBox/ShapeCheckBox";
import stl from "./CheckBox.module.css";
import { CDN_LINK } from "@globalConfig";
var CheckBox = function CheckBox(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange,
    checked = _ref.checked,
    logo = _ref.logo,
    alt = _ref.alt,
    count = _ref.count,
    color = _ref.color,
    option = _ref.option,
    isColorFilter = _ref.isColorFilter,
    carshape = _ref.carshape,
    carShapeImage = _ref.carShapeImage,
    carType = _ref.carType,
    disabled = _ref.disabled,
    filter = _ref.filter;
  return carshape ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ShapeCheckBox, {
    name: carType,
    count: count,
    image: carShapeImage,
    disabled: disabled,
    onChange: function onChange() {
      _onChange(filter, option, (filter === null || filter === void 0 ? void 0 : filter.filterField) === "condition_id" ? true : false);
    },
    checked: checked,
    value: value
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
    id: "filter-checkbox-".concat(value),
    className: stl.container,
    "data-disable": disabled
  }, isColorFilter && /*#__PURE__*/React.createElement("div", {
    className: stl.colorBox,
    style: {
      backgroundImage: !color ? "url(/assets/images/multiColor.png)" : undefined,
      backgroundColor: color,
      borderColor: color.indexOf("FFFFFF") > -1 ? "#cdd1d4" : "transparent"
    }
  }), logo && /*#__PURE__*/React.createElement("div", {
    className: stl.carLogo
  }, /*#__PURE__*/React.createElement("img", {
    src: logo,
    alt: alt
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.labelStyle
  }, label, " ", count && /*#__PURE__*/React.createElement("span", {
    className: stl.count
  }, "(", count, ")")), /*#__PURE__*/React.createElement(CostumeCheckBox, {
    disabled: disabled,
    className: stl.checkboxStyle,
    onChange: function onChange() {
      _onChange(filter, option, (filter === null || filter === void 0 ? void 0 : filter.filterField) === "condition_id");
    },
    checked: checked,
    src: CDN_LINK + "/assets/images/search-checkbox.svg",
    value: value
  })));
};
export default CheckBox;